module.exports = __webpack_public_path__ + "static/img/自动化操作全面升级收付款认领.aef78046.png";